import { useMutation, UseMutationResult } from 'react-query';
import { resendVerificationCode } from '@creditas-lab/auth-sdk';
import { handleMutationError, MutationBaseProps } from '../../services/queryClient';

export type ResendVerificationCodeResponse = {
  verificationTicket: string;
  verificationTicketExpiresInSeconds: number;
};

const useResendVerificationCode = ({
  onSuccess,
  onError,
}: MutationBaseProps<ResendVerificationCodeResponse> = {}): UseMutationResult<
  ResendVerificationCodeResponse,
  Error
> =>
  useMutation(resendVerificationCode, {
    onSuccess,
    onError: handleMutationError(onError),
  });

export { useResendVerificationCode };
